/**
 * The release phase each module ships in.
 *
 * Chapter 5 core is always present; optional domains own their routes and arrive with their phase.
 * Which module a screen belongs to is declared where the screen is registered: every view in
 * `shell/navigation.ts` names its module, so a destination appears as soon as one of its views is
 * enabled and an optional view disappears on its own.
 */
export const MODULES = {
  CORE: { phase: 1 },
  INVENTORY: { phase: 2 },
  BILLING: { phase: 2 },
  FIELD: { phase: 3 },
  ROUTING: { phase: 3 },
  PAYROLL: { phase: 4 },
} as const;

export type ModuleId = keyof typeof MODULES;
